'use client'

import useLogin from '@hook/useLogin'
import { Avatar } from '@comp/material'
import { useTranslations } from 'next-intl'
import { get } from 'lodash-es'
import CommentInputContent from './content'

export default function CommentInput({
  newsId,
  topicId,
  commentType,
  onAdd
}) {
  const ts = useTranslations('article')
  const { user, isLogin } = useLogin()

  return (
    <div>
      <div className="text-f.9">{ts('comment')}</div>
      <div className="bg-cf5 p-pix-10 md:p-pix-20 mt-pix-20 flex flex-col md:flex-row md:items-start gap-pix-10">
        <Avatar
          src={isLogin ? get(user, 'avatar', '') : ''}
        />
        <div className="flex-1 min-w-0">
          <CommentInputContent
            newsId={newsId}
            topicId={topicId}
            onAdd={onAdd}
            commentType={commentType}
          />
        </div>
      </div>
    </div>
  )
}
